import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-search",
  "use": "various-search-usage",
  "viewBox": "0 0 42 42",
  "content": "<symbol viewBox=\"0 0 42 42\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-search\"><path d=\"M28.375 24.133L41.98 37.738l-4.242 4.242-13.605-13.605A15.428 15.428 0 0115.5 31C6.94 31 0 24.06 0 15.5 0 6.94 6.94 0 15.5 0 24.06 0 31 6.94 31 15.5c0 3.196-.967 6.166-2.625 8.633zM15.5 25a9.5 9.5 0 100-19 9.5 9.5 0 000 19z\" fill-rule=\"nonzero\" fill=\"#e3000f\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol